<template>
  <div
    :class="[
      'full-screen-loader align-center h-full flex-col justify-center',
      `full-screen-loader--background-${background}`,
      {
        'full-screen-loader--rounded': rounded,
      },
    ]"
  >
    <OwnProgressSpinner size="20" color="misc-brand" />
  </div>
</template>

<script lang="ts" setup>
import { OwnProgressSpinner } from '@/ui/OwnProgressSpinner'

withDefaults(
  defineProps<{
    background?: 'primary' | 'secondary'
    rounded?: boolean
  }>(),
  {
    background: 'primary',
    rounded: false,
  }
)
</script>

<style lang="scss" scoped>
.full-screen-loader {
  &--rounded {
    border-radius: 16px;
  }

  &--background-primary {
    background-color: var(--background-primary);
  }
  &--background-secondary {
    background-color: var(--background-secondary);
  }
}
</style>
